import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { SnackbarService } from '@shared';

import { FilesService } from '../../services';
import {
  deleteFileFailure,
  deleteFileSuccess,
  FilesActionTypes,
  getFilesFailure,
  getFilesSuccess,
  uploadFileFailure,
  uploadFileSuccess,
} from '../actions';

import { IFile } from '@shared';
import { ErrorsService } from '@app/errors/errors.service';

@Injectable()
export class FilesEffects {
  constructor(
    private _actions$: Actions,
    private _filesService: FilesService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
  ) {}

  getFiles$ = createEffect(() =>
    this._actions$.pipe(
      ofType(FilesActionTypes.GET_FILES),
      mergeMap(({ id }) =>
        this._filesService.getFiles(id).pipe(
          map((data: any) => getFilesSuccess({ files: data.results })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getFilesFailure());
          }),
        ),
      ),
    ),
  );

  uploadFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(FilesActionTypes.UPLOAD_FILE),
      mergeMap(({ id, file, file_type }) =>
        this._filesService.uploadFile(id, file, file_type).pipe(
          map((file: IFile) => uploadFileSuccess({ file })),
          catchError(() => of(uploadFileFailure())),
        ),
      ),
    ),
  );

  deleteFile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(FilesActionTypes.DELETE_FILE),
      mergeMap(({ id }) =>
        this._filesService.deleteFile(id).pipe(
          map(() => deleteFileSuccess({ id })),
          catchError(() => of(deleteFileFailure())),
        ),
      ),
    ),
  );
}
